import { render, staticRenderFns } from "./ConfigDialog.vue?vue&type=template&id=3b678145&scoped=true&"
import script from "./ConfigDialog.vue?vue&type=script&lang=js&"
export * from "./ConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b678145",
  null
  
)

export default component.exports